import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import ChangeOrderStatusButton, { IStateProps, IDispatchProps, IOwnProps } from './ChangeOrderStatusButton'
import { IStoreState } from '../../services/store/IStoreState'
import { DashboardAction, requestOrderStatusChange } from '../../services/store/actions/dashboard/DashboardAction'

function mapStateToProps(): IStateProps {
  return {
  }
}

function mapDispatchToProps(dispatch: Dispatch<DashboardAction>): IDispatchProps {
  return {
    requestOrderStatusChange: (orderId, nextStatus) => dispatch(requestOrderStatusChange({orderId, nextStatus})),
  }
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(ChangeOrderStatusButton)
